import { useContext, useMemo } from 'react';
import { SelectDetailedContext } from 'src/components/atomic/layouts/selectDetailedProvider/SelectDetailedProvider';

interface SelectDetailedContextValues {
    activeSelectDetailedId: string;
    changeActiveSelectDetailedId: (id: string) => void;
    uniqueId: string;
    preventClose: boolean;
    setPreventClose: (value: boolean) => void;
}

export const useSelectDetailedContext = (): SelectDetailedContextValues => {
    const {
        activeSelectDetailedId,
        changeActiveSelectDetailedId,
        generateSelectDetailedUniqueId,
        preventClose,
        setPreventClose
    } = useContext(SelectDetailedContext);

    const uniqueId = useMemo(() => generateSelectDetailedUniqueId(), []);

    return {
        activeSelectDetailedId,
        changeActiveSelectDetailedId,
        uniqueId,
        preventClose,
        setPreventClose
    };
};
